import Swal from "sweetalert2";
import {
  ADDOFFER,
  ADDWHATAPPMESSAGECOUNT,
  GETALLOFFER,
  GETWHATPPMESSAGECOUNT,
  GETWHATSAPPMESSAGESETTINGS,
  UPDATEIMAGE,
  UPDATEOFFERMESSAGE,
  UPDATEOFFERMessage,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getAllOffer = async (callback) => {
  await axios.get(GETALLOFFER).then((res) => {
    console.log("dres ", res?.data);
    callback(res?.data);
  });
};

export const addOffer = async (payload, callback) => {
  await axios.post(ADDOFFER, payload).then((res) => {
    console.log("dres ", res?.data);
    callback(res?.data);
    if (res?.data?.succeeded) {
      Swal.fire({
        text: "Successfully added",
        icon: "success",
        ...swalAlertPopProps,
      });
    } else {
      Swal.fire({
        text: res?.data?.message,
        icon: "error",
        ...swalAlertPopProps,
      });
    }
  });
};

export const updateOffer = async (payload, callback) => {
  await axios.post(UPDATEOFFERMESSAGE, payload).then((res) => {
    console.log("dres ", res?.data);
    callback(res?.data);
    if (res?.data?.succeeded) {
      Swal.fire({
        text: "Successfully Updated",
        icon: "success",
        ...swalAlertPopProps,
      });
    } else {
      Swal.fire({
        text: res?.data?.message,
        icon: "error",
        ...swalAlertPopProps,
      });
    }
  });
};

export const bulImageUpload = async (payload, callback) => {
  await axios
    .post(UPDATEIMAGE, payload)
    .then((res) => {
      console.log(res);
      callback(res);
    })
    .catch((err) => {
      console.log("data");
    });
};

// import axios from "axios";

/**
 * Check WABridge device balance
 * @returns {Promise<number>} - returns available balance
 */
// export const getDeviceBalance = async () => {
//   try {
//     const res = await axios.post(
//       "https://web.wabridge.com/api/get-device-credit",
//       {
//         "app-key": "68b71452-6c72-4e16-92fa-f78d7328df3c",
//         "auth-key": "9d9bced6b415ff1e3b7ab141c8c02bce19a5091e89505992c7",
//         device_id: "6738338037d156722c02c587",
//       },
//       {
//         headers: { "Content-Type": "application/json" },
//       }
//     );

//     if (res.data && res.data.status) {
//       return res.data.balance || 0;
//     } else {
//       console.error("Error fetching balance:", res.data.message);
//       return 0;
//     }
//   } catch (err) {
//     console.error("Error calling WABridge balance API:", err);
//     return 0;
//   }
// };

// original
export const bulkMessageApload = async (payload, callback) => {
  console.log("payloadbulk message ", payload);
  await axios
    .post("https://web.wabridge.com/api/createmessage", payload)
    .then((res) => {
      console.log("whatrres ", res);
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
      Swal.fire({
        text: "Successfully Send",
        icon: "success",
        ...swalAlertPopProps,
      });
    })
    .catch((err) => {
      console.log("err ", err);
    });
};
// 2nd
// export const bulkMessageApload = async (payload, callback) => {
//   console.log("bulkMessageApload: sending payload:", payload);
//   try {
//     const res = await axios.post(
//       "https://web.wabridge.com/api/createmessage",
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     console.log("bulkMessageApload: response:", res.data);
//     callback(res);
//   } catch (err) {
//     console.error(
//       "bulkMessageApload: error sending:",
//       err.response || err.message || err
//     );
//     throw err; // propagate so caller knows
//   }
// };


// Match with android
// export const bulkMessageApload = async (payload, callback) => {
//   try {
//     // Construct request body like Android code
//     const requestBody = {
//       "app-key": payload["app-key"],
//       "auth-key": payload["auth-key"],
//       device_id: payload.device_id,
//       template_id: payload.template_id,
//       destination_number: payload.destination_number,
//       variables: payload.variables || [], // variables as array
//     };

//     if (payload.media) {
//       requestBody.media = payload.media;
//     }

//     console.log("Sending payload:", requestBody);

//     const res = await axios.post(
//       "https://web.wabridge.com/api/createmessage",
//       requestBody,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     console.log("WABridge response:", res.data);

//     // Call the callback with response
//     callback(res);

//     // Show success or error based on API response
//     if (res?.data?.succeeded) {
//       console.log("Message sent successfully");
//       // Swal.fire({
//       //   text: "Message sent successfully",
//       //   icon: "success",
//       // });
//     } else {
//       console.error("Error sending message:");

//       // Swal.fire({
//       //   text: res?.data?.message || "Failed to send message",
//       //   icon: "error",
//       // });
//     }
//   } catch (err) {
//     console.error("Error sending message:", err);
//     Swal.fire({
//       text: err.response?.data?.message || "Server or network error",
//       icon: "error",
//     });
//   }
// };

// export const bulkMessageApload = async (payload, callback) => {
//   try {
//     const res = await axios.post("http://localhost:5000/send-message", payload);

//     console.log("Backend response:", res.data);

//     if (res.data.succeeded || res.data.status) {
//       Swal.fire({
//         text: "Message queued successfully",
//         icon: "success",
//       });
//     } else {
//       Swal.fire({
//         text: res.data.message || "Message could not be sent",
//         icon: "error",
//       });
//     }

//     callback(res.data);
//   } catch (err) {
//     console.error("Error sending message:", err);
//     Swal.fire({
//       text: err.response?.data?.message || "Server error",
//       icon: "error",
//     });
//   }
// };
export const addMessageCount = async (payload, callback) => {
  await axios.post(ADDWHATAPPMESSAGECOUNT, payload).then((res) => {
    callback(res);
  });
};

export const getMessageCount = async (callback) => {
  await axios.get(GETWHATPPMESSAGECOUNT).then((res) => {
    callback(res);
  });
};

export const getBulkWhatsappMessage = async (callback) => {
  await axios.get(GETWHATSAPPMESSAGESETTINGS).then((res) => {
    callback(res);
  });
};
